import { Component, Input, OnInit } from "@angular/core";

export interface RouterLinkAction {
  kind: "router";
  route: any[] | string;
  disabled?: boolean;
}

export interface CallbackAction {
  kind: "callback";
  onAction: () => void;
  disabled?: boolean;
}

export interface LinkAction {
  kind: "link";
  url: string;
  target?: "_blank" | "_top" | "_parent";
  disabled?: boolean;
}

export interface IAction {
  content?: string;
  icon?: string;
  action: RouterLinkAction | CallbackAction | LinkAction;
}

export interface IActionGroups {
  title?: string;
  icon?: string;
  actions: IAction[];
}

@Component({
  selector: 'solaryum-page',
  templateUrl: './solaryum-page.component.html',
  styleUrls: ['./solaryum-page.component.scss']
})
export class SolaryumPageComponent implements OnInit {
  @Input() title?: string;
  @Input() backAction?: RouterLinkAction | CallbackAction | LinkAction;
  @Input() primaryAction?: IAction;
  @Input() secondaryAction?: IAction;
  @Input() destructiveAction?: IAction;
  @Input() actionGroups?: IActionGroups;
  @Input() descritpion?: string;

  constructor() { }

  ngOnInit() {
  }
}
